import {Component, OnInit} from '@angular/core';
import {AppState} from '../../../reducers';
import {Store} from '@ngrx/store';
import {selectRegisterState} from '../selectors/register.selectors';
import {Observable} from 'rxjs';
import {State} from '../reducers/register.reducer';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  registerStatus$: Observable<State>;


  constructor(private store: Store<AppState>, private router: Router) {
  }

  ngOnInit(): void {
    /*
    this.registerStatus$ = this.store.select(selectRegisterState).pipe(map(state => {
      if (!state.success) {
        this.router.navigate(['/']);
        return state;
      }
      return state;
    }));
    */
  }

}
